export const addParamToUrl = (url: string, param: string, value: string) => {
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.append(param, value);
    return urlObj.toString();
  } catch (e) {
    return url;
  }
};
